import { RouteFactory } from "@app/routePaths";
import { AdvertisementTypeEnum } from "@app/types/enums";
import uobLogo from "@assets/logo-uob-blue.png";
import aseanBusinessLogo from "@assets/verticals/asean-logo-black.svg";
import Advertisement from "@components/Advertisement/Advertisement";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function AseanBanner(): React.ReactElement {
  return (
    <>
      <SectionMasthead
        link={RouteFactory.aseanBusiness}
        masthead={{
          alt: "Asean Business logo",
          src: aseanBusinessLogo,
          width: 240,
          height: 57,
        }}
      />

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex items-center justify-end gap-x-4">
          <span className="font-poppins text-base font-light">
            SPONSORED BY
          </span>
          <img src={uobLogo} alt="UOB logo" width="140" />
        </div>
      </Banner>

      <Advertisement
        rootClassName="pb-6"
        adUnitProps={{
          slot: GoogleAdsSlotFactory.lb1(
            RouteFactory.aseanBusiness.replace("/", "")
          ),
          type: AdvertisementTypeEnum.LB1,
        }}
      />

      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.CATFISH,
          slot: GoogleAdsSlotFactory.lb1(
            RouteFactory.aseanBusiness.replace("/", "")
          ),
        }}
      />
    </>
  );
}
